'use client';

import { motion } from 'framer-motion';

export default function StatCard({ stat, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      className="stats-card bg-gray-800 border border-gray-700 rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-200"
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="text-sm font-medium text-white">{stat.title}</h3>
          <p className="text-xl font-bold mt-1 text-white">{stat.value}</p>
          {stat.change && (
            <div className="flex items-center mt-1">
              <span className="text-xs text-green-400 font-medium">{stat.change}</span>
              <span className="text-[10px] text-white ml-1">vs last month</span>
            </div>
          )}
        </div>
        <stat.icon className={`w-6 h-6 ${stat.color} flex-shrink-0`} />
      </div>
    </motion.div>
  );
}